module.exports = __webpack_public_path__ + "static/media/core-creators.7ef9277a.md";